import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMapSlice } from '../../../slice';
import {
  selectNotSelectedMappedFields,
  selectOnlySelectedMappedFields,
} from '../../../slice/selectors';
import {
  IMappedField,
  IProgressModalState,
  MapModeEnum,
} from '../../../slice/types';
import { Field } from '../../fields/Field/Field';
import { Modal, Row, Select } from 'antd';
import DisabledField from '../../fields/DisabledField/DisabledField';

const PROGRESS_OPTIONS = [0, 20, 40, 60, 80, 100];

const ProgressUpdateFields = () => {
  const mappedFields = useSelector(selectOnlySelectedMappedFields);
  const notSelectedFields = useSelector(selectNotSelectedMappedFields);

  const dispatch = useDispatch();

  const { actions } = useMapSlice();

  useEffect(() => {
    if (mappedFields.length) {
      dispatch(actions.fitAllPolygonsOnMap());
    }
  }, [dispatch, actions, mappedFields.length]);

  const onFieldClick = (field: IMappedField) => {
    setProgressModalState({ visible: true, field });
  };

  const [progressModalState, setProgressModalState] = useState<
    IProgressModalState
  >({ visible: false });

  const toggleModal = (visible: boolean) => {
    setProgressModalState({ visible });
  };

  const onProgressSelect = (value: number) => {
    if (progressModalState?.field) {
      dispatch(
        actions.setSingleFieldProgress({
          fieldId: progressModalState.field.fieldParameters.fieldId,
          progress: value,
        }),
      );
    }
    toggleModal(false);
  };

  return (
    <>
      {mappedFields.map(mappedField => (
        <Field
          mode={MapModeEnum.progress}
          eventHandlers={{
            click() {
              onFieldClick(mappedField);
            },
          }}
          mappedField={mappedField}
          key={mappedField.id}
          isSelected={mappedField.isSelected}
        />
      ))}
      {notSelectedFields.map(mappedField => (
        <DisabledField mappedField={mappedField} key={mappedField.id} />
      ))}
      <Modal
        title={
          <>
            <Row>
              {`${
                progressModalState?.field?.fieldParameters.cultureName ||
                progressModalState?.field?.fieldParameters.name
              } `}
            </Row>
            <Row>{`(${progressModalState?.field?.fieldParameters.area})`}</Row>
          </>
        }
        width={250}
        centered
        visible={progressModalState.visible}
        footer={null}
        onCancel={() => toggleModal(false)}
      >
        <Select
          value={progressModalState.field?.fieldProgressUpdate || 0}
          onSelect={onProgressSelect}
          dropdownMatchSelectWidth={false}
          style={{ width: '100%' }}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {PROGRESS_OPTIONS.map(optionVal => (
            <Select.Option value={optionVal} key={optionVal}>
              {optionVal}%
            </Select.Option>
          ))}
        </Select>
      </Modal>
    </>
  );
};

export default ProgressUpdateFields;
